import React, { Fragment } from 'react';
import Breadcrumbs from '../../../CommonElements/Breadcrumbs';
import CryptoContain from '../../../Component/DashBoard/Crypto';

const Crypto = () => {
  return (
    <Fragment>
      <CryptoContain />
    </Fragment>
  );
};
export default Crypto;